import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/internal/operators/map';
import { of } from 'rxjs';
import { ApplicationFormTransformService } from './application-form.transforms';
import { UtilityService } from '@app/shared/services/utility/utility.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationFormDataService {

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private logger: LoggerService,
        private transforms: ApplicationFormTransformService,
        private utilityService: UtilityService
    ) { }

    getApplicant() {
        const applicationId = sessionStorage.getItem('connect.applicationId');
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'applicants/' + applicationId + '?type=lead';

        if (applicationId !== '' || applicationId !== null) {
            return this.http.get(url, { observe: 'response' }).pipe(
                //typeof Applicant
                map((response: HttpResponse<any>) => this.transforms.getApplicantTransform(response)),
                catchError((error: any) => {
                    if (error.status === 404) { // not found
                        this.logger.error('getApplicant 404 not found', error);
                        // return null;
                    } else {
                        this.logger.error('getApplicant error', error.data);
                        // return null;
                    }
                    return of(error);
                })
            );
            // return of(this.transforms.getApplicantTransform(new HttpResponse({ body: this.testApplicant })))
        }

        return throwError(() => new Error("no applicationId found"));
    }

    postApplicant(formData: any) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'applicants/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        const transformedData = this.transforms.postApplicantTransform(formData);

        return this.http.post(url, transformedData, { headers, observe: 'response' }).pipe(
            //typeof Applicant
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postApplicant 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postApplicant error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
        // return of(new HttpResponse({ status: 200 }));
    }

    getJointApplicant(applicationId: string) {
        this.logger.info('getJointApplicant applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'applicants/' + applicationId + '?type=joint';

        return this.http.get(url, { observe: 'response' }).pipe(
            //typeof JointApplicant
            map((response: HttpResponse<any>) => this.transforms.getJointApplicantTransform(response)),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    // create empty model in Transform
                    const jointModel = error.data;
                    jointModel.applicationContactId = this.utilityService.newGuid();
                    jointModel.applicationId = applicationId;
                    this.logger.info("jointModel after \n" + JSON.stringify(jointModel));
                    return of(jointModel);

                } else {
                    this.logger.error(error);
                    // this.logger.error('An error has occurred \n url: ' + error.config.url + '\n method: ' + error.config.method + '\n status: ' + error.status + '\n text: ' + error.statusText + '\n data: ' + error.data);
                    return of(null);
                }
            })
        );

        // return of(this.transforms.getJointApplicantTransform(new HttpResponse({ body: this.testJointApplicant })));
    }

    postJointApplicant(formData: any, leadApplicantCurrentAddress: any) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'applicants/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        const transformedData = this.transforms.postJointApplicantTransform(formData, leadApplicantCurrentAddress);

        return this.http.post(url, transformedData, { headers, observe: 'response' }).pipe(
            //typeof JointApplicant
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postJointApplicant 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postJointApplicant error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
        // return of(new HttpResponse({ status: 200 }));
    }

    getAdditionalResidents(applicationId: string) {
        this.logger.info('getAdditionalResidents applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'additionalresidents/' + applicationId;

        return this.http.get(url, { observe: 'response' }).pipe(
            //typeof AdditionalResidents
            map((response: HttpResponse<any>) => this.transforms.getAdditionalResidentsTransform(response, applicationId)),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    // create empty model in Transform
                    const residentsModel = error.data;
                    residentsModel.applicationId = applicationId;
                    this.logger.info("empty residentsModel", residentsModel);
                    return of(residentsModel);

                } else {
                    this.logger.error('getAdditionalResidents an error has occurred ', error);
                    return of(null);
                }
            })
        );
    }

    postAdditionalResidents(formData: any) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'additionalresidents/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        const transformedData = this.transforms.postAdditionalResidentsTransform(formData);
        this.logger.info('postAdditionalResidents', JSON.stringify(formData));

        return this.http.post(url, transformedData, { headers, observe: 'response' }).pipe(
            //typeof AdditionalResidents
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postAdditionalResidents 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postAdditionalResidents error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }

    getAffordability(applicationId: string) {
        this.logger.info('getAffordability applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'IncomeExpenditure/' + applicationId;

        return this.http.get(url, { observe: 'response' }).pipe(
            map((response: HttpResponse<any>) => response.body),
            //typeof Affordability
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    // create empty model in Transform
                    const affordabilityModel = error.data;
                    affordabilityModel.applicationId = applicationId;
                    this.logger.info("empty affordabilityModel", affordabilityModel);
                    return of(affordabilityModel);

                } else {
                    this.logger.error('getAffordability an error has occurred ', error);
                    return of(null);
                }
            })
        );
    }

    postAffordability(formData: any, applicationId: string) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'IncomeExpenditure/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        formData.applicationId = applicationId;

        this.logger.info('postAffordability', JSON.stringify(formData));

        return this.http.post(url, formData, { headers, observe: 'response' }).pipe(
            //typeof Affordability
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postAffordability 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postAffordability error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }

    getSafeguarding() {
        this.logger.info('getSafeguarding');
        const applicationId = sessionStorage.getItem('connect.applicationId');

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'safeguarding/' + applicationId;

        if (applicationId !== '' || applicationId !== null) {
            return this.http.get(url, { observe: 'response' }).pipe(
                //typeof Safeguarding
                map((response: HttpResponse<any>) => this.transforms.getSafeguardingTransform(response)),
                catchError((error: any) => {
                    if (error.status === 404) { // not found
                        // create empty model in Transform
                        const safeguardingModel = error.data;
                        safeguardingModel.applicationId = applicationId;
                        this.logger.info("empty safeguardingModel", safeguardingModel);
                        return of(safeguardingModel);

                    } else {
                        this.logger.error('getAffordability an error has occurred ', error);
                        return of(null);
                    }
                })
            );
        }

        return throwError(() => new Error("no applicationId found"));
    }

    postSafeguarding(formData: any) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'safeguarding/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        this.logger.info('posting formdata', formData);

        return this.http.post(url, formData, { headers, observe: 'response' }).pipe(
            //typeof Safeguarding
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postSafeguarding 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postSafeguarding error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }

    getReferences(applicationId: string) {
        this.logger.info('getReferences applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'references/' + applicationId + '?type=lead';

        if (applicationId !== '' || applicationId !== null) {
            return this.http.get(url, { observe: 'response' }).pipe(
                //typeof References
                map((response: HttpResponse<any>) => this.transforms.getReferencesTransform(response)),
                catchError((error: any) => {
                    if (error.status === 404) { // not found
                        // create empty model in Transform
                        const referencesModel = error.data;
                        referencesModel.applicationId = applicationId;
                        this.logger.info("empty referencesModel", referencesModel);
                        return of(referencesModel);

                    } else {
                        this.logger.error('getReferences an error has occurred ', error);
                        return of(null);
                    }
                })
            );
        }

        return throwError(() => new Error("no applicationId found"));
    }

    postReferences(formData: any) {
        this.logger.info('postReferences formdata', formData);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'references/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        const transformedData = this.transforms.postReferencesTransform(formData);

        return this.http.post(url, transformedData, { headers, observe: 'response' }).pipe(
            //typeof References
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postReferences 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postReferences error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }

    getJointReferences(applicationId: string) {
        this.logger.info('getJointReferences applicationId', applicationId);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'references/' + applicationId + '?type=joint';

        if (applicationId !== '' || applicationId !== null) {
            return this.http.get(url, { observe: 'response' }).pipe(
                //typeof References
                map((response: HttpResponse<any>) => this.transforms.getJointReferencesTransform(response)),
                catchError((error: any) => {
                    if (error.status === 404) { // not found
                        // create empty model in Transform
                        const jointReferencesModel = error.data;
                        jointReferencesModel.applicationId = applicationId;
                        this.logger.info("empty jointReferencesModel", jointReferencesModel);
                        return of(jointReferencesModel);

                    } else {
                        this.logger.error('getReferences an error has occurred ', error);
                        return of(null);
                    }
                })
            );
        }

        return throwError(() => new Error("no applicationId found"));
    }

    postJointReferences(formData: any, jointModel: any) {
        this.logger.info('postJointReferences formdata', formData);

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'references/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        const transformedData = this.transforms.postJointReferencesTransform(formData, jointModel);

        return this.http.post(url, transformedData, { headers, observe: 'response' }).pipe(
            //typeof References
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('postJointReferences 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('postJointReferences error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }

    postTermsAndConditions(formData: any) {
        this.logger.info('postTermsAndConditions', JSON.stringify(formData));

        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'terms/';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=UTF-8',
        });

        return this.http.post(url, formData, { headers, observe: 'response' }).pipe(
            //typeof Terms
            map((response: HttpResponse<any>) => response),
        );

    }

    getNationalInsuranceNumber(niNumber: string, contactID: string, email?: string) {
        const url = this.configService.getConfig()?.shell.api.applicationApiUrl + 'NIValidation?niNumber=' + niNumber + "&contactID=" + contactID + "&email=" + email

        return this.http.get(url, { observe: 'response' }).pipe(
            map((response: any) => {
                return response;
            }),
            catchError((err: any) => { return of(err) })
        )

        // return throwError(() => new Error("no applicationId found"));
    }
}
